'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = require('./dialog');

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _dialog2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/dialog/index.js
// module id = 212
// module chunks = 0